import { IntlShape } from 'react-intl';
import { SerializedPresaveWidget } from 'fym-common/src/db/serializersTypes';
import { blockSummaryMessages as m } from './blockSummaryMessages';
import { autoAddedAtOf } from './autoAdded';
import type { BlockSummaryTone } from './describeBlock';

/** A day stored at midnight UTC, shown in UTC so it does not slide to the day before. */
export function formatReleaseDay(intl: IntlShape, value: string): string {
  return intl.formatDate(value, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
}

/** True for a block of a song that has a release day (a block with no campaign may have none). */
function hasReleaseDay(widget: SerializedPresaveWidget): boolean {
  return widget.data.releaseDate !== '' && !Number.isNaN(Date.parse(widget.data.releaseDate));
}

/**
 * The summary line of a Catalog links block (design d0, c1, c2, c7, e3): the pre-save until the
 * release day, or the count of live links that update by themselves.
 */
export function describeCatalogLinks(
  intl: IntlShape,
  widget: SerializedPresaveWidget
): { summary: string; tone: BlockSummaryTone } {
  const { data } = widget;
  if (data.released) {
    const count = Object.keys(data.resolvedUrls ?? {}).length;
    return count === 0
      ? { summary: intl.formatMessage(m.catalogNoLinks), tone: 'warn' }
      : { summary: intl.formatMessage(m.catalogLive, { count }), tone: 'pos' };
  }
  if (data.closed) {
    return { summary: intl.formatMessage(m.catalogClosed), tone: 'warn' };
  }
  const hasCampaign = data.hasCampaign !== false;
  if (!hasReleaseDay(widget)) {
    return { summary: intl.formatMessage(m.catalogNoDate), tone: 'normal' };
  }
  const date = formatReleaseDay(intl, data.releaseDate);
  if (!hasCampaign) {
    return { summary: intl.formatMessage(m.catalogUntilRelease, { date }), tone: 'normal' };
  }
  if (autoAddedAtOf(widget) !== null) {
    return { summary: intl.formatMessage(m.catalogAutoAdded, { date }), tone: 'normal' };
  }
  return { summary: intl.formatMessage(m.catalogPresave, { count: data.services.length, date }), tone: 'normal' };
}
